import { takeLeading, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/medication-config/actions';
import medsApi from 'src/services/api/medication-config';
import { handleErrorResponse } from 'src/lib/helpers/errors';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* get({ id }: any) {
  try {
    const response = yield call(medsApi.get, id);
    yield put(Creators.medicationConfGetRequestSuccess(response));
  } catch (e) {
    let error = e.response;
    DBErrorMonitor.captureException(e, {
      saga: 'get',
      entity: 'medication-config',
    });
    handleErrorResponse(error);
    yield put(Creators.medicationConfGetRequestError(error));
  }
}

export function* watchGet() {
  yield takeLeading(Types.MEDICATION_CONF_GET_REQUEST, get);
}

export default watchGet;
